import firebase from 'firebase/app'
import 'firebase/auth'

export default function auth({to, next, router}) {
	// console.log('name', to.name);
	if (!sessionStorage.getItem('auth'))
		return router.push({name: 'login'});
	else {
		firebase.auth().onAuthStateChanged(user => {
			if (!user) {
				sessionStorage.setItem('auth','');
				return router.push({name: 'login'});
			}
		});
	}

	return next();
}